/**
 * 动态换图类型
 * @since 1.1.0
 */
export var BackgroundType;
(function (BackgroundType) {
    BackgroundType["video"] = "video";
    BackgroundType["image"] = "image";
})(BackgroundType || (BackgroundType = {}));
/**
 * 多媒体资源类型
 * @since 2.1.0
 */
export var MultimediaType;
(function (MultimediaType) {
    MultimediaType["video"] = "video";
    MultimediaType["audio"] = "audio";
})(MultimediaType || (MultimediaType = {}));
export var HevcVideoCodec;
(function (HevcVideoCodec) {
    HevcVideoCodec["L30"] = "hev1.1.0.L30.B0";
    HevcVideoCodec["L60"] = "hev1.1.0.L60.B0";
    HevcVideoCodec["L63"] = "hev1.1.0.L63.B0";
    HevcVideoCodec["L90"] = "hev1.1.0.L90.B0";
    HevcVideoCodec["L93"] = "hev1.1.0.L93.B0";
    HevcVideoCodec["L120"] = "hev1.1.0.L120.B0";
    HevcVideoCodec["L150"] = "hev1.1.0.L150.B0";
    HevcVideoCodec["L180"] = "hev1.1.0.L180.B0";
})(HevcVideoCodec || (HevcVideoCodec = {}));
